import * as React from "react";
import PropTypes from 'prop-types';

const SvgHalloweenDay = props => {
  if (props.id !== "_svghalloweenday") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 144 144" {...props}><g fill="none" fillRule="evenodd"><path d="M61.797 42.195c1.077-4.578 2.873-8.935 5.39-13.07C71.272 22.417 76.084 18.042 81.626 16h7c-4.832 0-8.75 7.835-8.75 17.5 0 2.785.325 5.418.904 7.756-2.7-1.623-5.642-2.506-8.779-2.506-3.697 0-7.126 1.227-10.203 3.445z" fill="#8b572a" /><g fill="#f5a623" transform="translate(16 16)"><path d="M41.516 30.168C34.209 38.626 29.75 53.444 29.75 70s4.459 31.374 11.766 39.832C38.369 111.238 35 112 31.5 112 14.103 112 0 93.196 0 70s14.103-42 31.5-42c3.501 0 6.87.762 10.016 2.168zm28.968 79.664C77.791 101.374 82.25 86.556 82.25 70s-4.459-31.374-11.766-39.832C73.631 28.762 77 28 80.5 28 97.897 28 112 46.804 112 70s-14.103 42-31.5 42c-3.501 0-6.87-.762-10.016-2.168z" /><ellipse cx={56} cy={70} rx={21} ry={42} /></g></g></svg>;
};

SvgHalloweenDay.displayName = "_svghalloweenday";
SvgHalloweenDay.propTypes = {
  id: PropTypes.string
};
SvgHalloweenDay.defaultProps = {
  id: ''
};
export default SvgHalloweenDay;